const types = {
    SET_SUPPORT_LIST: '[SUPPORT] SET SUPPORT LIST',
    SET_SUPPORT_VIEW: '[SUPPORT] SET SUPPORT VIEW'
}

export {
    types
}